import { createContext, useContext } from 'react';

interface ToastContextValue {
  createdAt: number;
  duration?: number;
  id: string;
}

export const ToastContext = createContext<null | ToastContextValue>(null);

export const useToastContext = (): null | ToastContextValue => {
  const toastContext = useContext(ToastContext);

  return toastContext;
};
